import React from "react";

/** Dashed placeholder circle for a chip that has nothing chosen yet. */
export default function EmptyAvatar() {
  return (
    <div className="flex-none w-[28px] h-[28px] rounded-full box-border border-[1.5px] border-dashed border-interaction-primary-faded bg-interaction-primary-washed" />
  );
}
